interface Props {
  children?: React.ReactNode;
}

export const DropDownContainer: React.FC<Props> = ({ children }) => {
  return <div className="space-y-1.5 py-3 ">{children}</div>;
};
